import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Login from "./pages/Login"
import PrivateRoute from "./components/common/PrivateRoute"

import PrivateLayout from './components/layout/PrivateLayout';
import { AuthContextProvider } from "./context/AuthContext";
import AuthRedirect from "./components/AuthRedirect";
import MigrationDetails from "./pages/MigrationDetails";
import MigrationList from "./pages/MigrationList";
import MigrateAPIs from "./pages/MigrationTool";
import { LanguageProvider } from "./context/LanguageContext";

const theme = createTheme({
  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
      },
    },
  },
})

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LanguageProvider>
        {" "}
        {/* Agregamos el LanguageProvider */}
        <AuthContextProvider>
          <Router>
            <AuthRedirect />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<PrivateRoute />}>
                <Route element={<PrivateLayout />}>
                  <Route path="migrate" element={<MigrateAPIs />} />
                  <Route path="migrations" element={<MigrationList />} />
                  <Route path="migration/:id" element={<MigrationDetails />} />
                </Route>
              </Route>
            </Routes>
          </Router>
        </AuthContextProvider>
      </LanguageProvider>
    </ThemeProvider>
  )
}

export default App